var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_16961)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.707 61.8164C299.707 65.332 299.707 68.8477 299.707 72.3633C298.644 76.244 296.789 79.7596 294.141 82.9102C234.082 142.969 174.023 203.027 113.965 263.086C109.536 266.121 104.654 267.097 99.3164 266.016C96.9053 265.299 94.7566 264.127 92.8711 262.5C62.8746 232.699 33.0892 202.718 3.51562 172.559C2.05409 169.836 0.784559 167.101 -0.292969 164.355C-0.292969 160.84 -0.292969 157.324 -0.292969 153.809C0.719144 150.222 2.3793 146.902 4.6875 143.848C9.68543 138.654 14.8612 133.673 20.2148 128.906C29.5345 123.667 38.7142 123.862 47.7539 129.492C66.4061 148.144 85.0588 166.797 103.711 185.449C152.832 136.328 201.953 87.2068 251.074 38.0859C260.176 31.9121 269.551 31.5215 279.199 36.9141C286.177 42.719 292.329 49.2619 297.656 56.543C298.376 58.3584 299.059 60.116 299.707 61.8164Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_16961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check 1.2891ca3b8088872e7c2dbe6f32d6308f.svg";
export { ForwardRef as ReactComponent };